export default import.meta.ROLLDOWN_FILE_URL_4L8X5Y0W5Xr4aSsV2zlAig